import { render, staticRenderFns } from "./EmptyNoData.vue?vue&type=template&id=42905b88&scoped=true&"
import script from "./EmptyNoData.vue?vue&type=script&lang=js&"
export * from "./EmptyNoData.vue?vue&type=script&lang=js&"
import style0 from "./EmptyNoData.vue?vue&type=style&index=0&id=42905b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42905b88",
  null
  
)

export default component.exports